<template>
  <form id="contactApprovalForm" action="/api/update_request/contact" method="POST" class="text-left text-sm">
    <div class="form-row">
      <div class="col-12">
        <div class="text-lg mb-2">
          Pending contact approval:
          <ul>
            <li v-for="(request_data, key) in update_requests" :key="key">
              <span v-if="request_data.source"
                >from Placement:
                <a :href="`/placement/edit/${request_data.source.id}`" target="_blank">
                  {{ request_data.source.policyholder.name }}
                </a>
                <br />
              </span>
              made by: {{ request_data.changed_by }} on
              {{ formatDate(request_data.updated_at) }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-sm-12">
        <h5 class="font-weight-bold bg-light p-2 mb-3 border-bottom text-xl">Contact Info <sup v-if="isNew" class="text-danger">(NEW!)</sup></h5>
      </div>
    </div>

    <div class="form-row">
      <div class="col-sm-4">
        <div class="form-group" v-if="field_update_options['name'] && field_update_options['name'].length">
          <div class="tooltip-v2">
            <div v-if="(data.name || update_data.name) && data.name != update_data.name">
              <div class="tooltip-v2-text left" v-html="data.name ? data.name : 'Not filled yet'"></div>
              <label class="form-control-wrap">
                Name <span style="color: #ff1d25;">*</span> <span class="d-inline text-success visible">*</span>
              </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Name <span style="color: #ff1d25;">*</span></label>
            </div>

            <v-select v-model="update_data.name" class="form-control" name="name" :options="field_update_options['name']"></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Name <span style="color: #ff1d25;">*</span></label>
          <div class="form-control-wrap">
            <v-text v-model="update_data.name" class="form-control alphanumeric-field " autocomplete="off" name="name" placeholder=""></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group" v-if="field_update_options['position'] && field_update_options['position'].length">
          <div class="tooltip-v2">
            <div v-if="(data.position || update_data.position) && data.position != update_data.position">
              <div class="tooltip-v2-text left" v-html="data.position ? data.position : 'Not filled yet'"></div>
              <label class="form-control-wrap">Title <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Title</label>
            </div>

            <v-select v-model="update_data.position" class="form-control" name="position" :options="field_update_options['position']"></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Title</label>
          <div class="form-control-wrap">
            <v-text
              v-model="update_data.position"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="position"
              placeholder=""
            ></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group" v-if="field_update_options['email'] && field_update_options['email'].length">
          <div class="tooltip-v2">
            <div v-if="(data.email || update_data.email) && data.email != update_data.email">
              <div class="tooltip-v2-text left" v-html="data.email ? data.email : 'Not filled yet'"></div>
              <label class="form-control-wrap">Email <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Email</label>
            </div>

            <v-select v-model="update_data.email" class="form-control" name="email" :options="field_update_options['email']"></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Email</label>
          <div class="form-control-wrap">
            <v-text v-model="update_data.email" class="form-control alphanumeric-field " autocomplete="off" name="email" placeholder=""></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-sm-4">
        <div class="form-group" v-if="field_update_options['phone'] && field_update_options['phone'].length">
          <div class="tooltip-v2">
            <div v-if="(data.phone || update_data.phone) && data.phone != update_data.phone">
              <div class="tooltip-v2-text left" v-html="data.phone ? data.phone : 'Not filled yet'"></div>
              <label class="form-control-wrap">Cell Phone <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Cell Phone</label>
            </div>

            <v-select v-model="update_data.phone" class="form-control" name="phone" :options="field_update_options['phone']"></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Cell Phone</label>
          <div class="form-control-wrap">
            <v-phone v-model="update_data.phone" type="text" class="form-control" name="phone" autocomplete="off" placeholder=""></v-phone>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group" v-if="field_update_options['office'] && field_update_options['office'].length">
          <div class="tooltip-v2">
            <div v-if="(data.office || update_data.office) && data.office != update_data.office">
              <div class="tooltip-v2-text left" v-html="data.office ? data.office : 'Not filled yet'"></div>
              <label class="form-control-wrap">Direct Office Phone <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Direct Office Phone</label>
            </div>

            <v-select v-model="update_data.office" class="form-control" name="office" :options="field_update_options['office']"></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Direct Office Phone</label>
          <div class="form-control-wrap">
            <v-phone v-model="update_data.office" type="text" class="form-control" name="office" autocomplete="off" placeholder=""></v-phone>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group" v-if="field_update_options['office_ext'] && field_update_options['office_ext'].length">
          <div class="tooltip-v2">
            <div v-if="(data.office_ext || update_data.office_ext) && data.office_ext != update_data.office_ext">
              <div class="tooltip-v2-text left" v-html="data.office_ext ? data.office_ext : 'Not filled yet'"></div>
              <label class="form-control-wrap">Office Ext. <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Office Ext.</label>
            </div>

            <v-select
              v-model="update_data.office_ext"
              class="form-control"
              name="office_ext"
              :options="field_update_options['office_ext']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Office Ext.</label>
          <div class="form-control-wrap">
            <v-text
              v-model="update_data.office_ext"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="office_ext"
              placeholder=""
            ></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-sm-4">
        <div class="form-group">
          <label class="mb-1">Contact Type</label>
          <div class="mb-3">
            <span class="badge badge-gray">
              {{ data.type.name }}
            </span>
          </div>
        </div>
      </div>

      <div class="col" v-if="data.type_id == 4">
        <div class="form-group">
          <label class="mb-1">Other Type Info</label>
          <div class="mb-3">
            <span class="badge badge-gray">
              {{ data.other_type_info }}
            </span>
          </div>
        </div>
      </div>

      <div class="col" v-if="data.type_id == 3">
        <div class="form-group" v-if="field_update_options['license_number'] && field_update_options['license_number'].length">
          <div class="tooltip-v2">
            <div v-if="(data.license_number || update_data.license_number) && data.license_number != update_data.license_number">
              <div class="tooltip-v2-text left" v-html="data.license_number ? data.license_number : 'Not filled yet'"></div>
              <label class="form-control-wrap">License Number <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">License Number</label>
            </div>

            <v-select
              v-model="update_data.license_number"
              class="form-control"
              name="license_number"
              :options="field_update_options['license_number']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">License Number</label>
          <div class="form-control-wrap">
            <v-text
              v-model="update_data.license_number"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="license_number"
              placeholder=""
            ></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col">
        <div class="form-group" v-if="field_update_options['personal_identifier'] && field_update_options['personal_identifier'].length">
          <div class="tooltip-v2">
            <div v-if="(data.personal_identifier || update_data.personal_identifier) && data.personal_identifier != update_data.personal_identifier">
              <div class="tooltip-v2-text left" v-html="data.personal_identifier ? data.personal_identifier : 'Not filled yet'"></div>
              <label class="form-control-wrap">Personal Identifier <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Personal Identifier</label>
            </div>

            <v-select
              v-model="update_data.personal_identifier"
              class="form-control"
              name="personal_identifier"
              :options="field_update_options['personal_identifier']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Personal Identifier</label>
          <div class="form-control-wrap">
            <v-text
              v-model="update_data.personal_identifier"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="personal_identifier"
              placeholder=""
            ></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>
      <div class="col">
        <div class="form-group" v-if="field_update_options['personal_guidelines'] && field_update_options['personal_guidelines'].length">
          <div class="tooltip-v2">
            <div v-if="(data.personal_guidelines || update_data.personal_guidelines) && data.personal_guidelines != update_data.personal_guidelines">
              <div class="tooltip-v2-text left" v-html="data.personal_guidelines ? data.personal_guidelines : 'Not filled yet'"></div>
              <label class="form-control-wrap">Personal Guidelines <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Personal Guidelines</label>
            </div>

            <v-select
              v-model="update_data.personal_guidelines"
              class="form-control"
              name="personal_guidelines"
              :options="field_update_options['personal_guidelines']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Personal Guidelines</label>
          <div class="form-control-wrap">
            <v-text
              v-model="update_data.personal_guidelines"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="personal_guidelines"
              placeholder=""
            ></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="col">
        <div class="form-group" v-if="field_update_options['invoicing_preferences'] && field_update_options['invoicing_preferences'].length">
          <div class="tooltip-v2">
            <div
              v-if="
                (data.invoicing_preferences || update_data.invoicing_preferences) && data.invoicing_preferences != update_data.invoicing_preferences
              "
            >
              <div class="tooltip-v2-text left" v-html="data.invoicing_preferences ? data.invoicing_preferences : 'Not filled yet'"></div>
              <label class="form-control-wrap">Invoicing Preferences <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Invoicing Preferences</label>
            </div>

            <v-select
              v-model="update_data.invoicing_preferences"
              class="form-control"
              name="invoicing_preferences"
              :options="field_update_options['invoicing_preferences']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Invoicing Preferences</label>
          <div class="form-control-wrap">
            <v-text
              v-model="update_data.invoicing_preferences"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="invoicing_preferences"
              placeholder=""
            ></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col">
        <div class="form-group" v-if="field_update_options['negotiated_fees'] && field_update_options['negotiated_fees'].length">
          <div class="tooltip-v2">
            <div v-if="(data.negotiated_fees || update_data.negotiated_fees) && data.negotiated_fees != update_data.negotiated_fees">
              <div class="tooltip-v2-text left" v-html="data.negotiated_fees ? data.negotiated_fees : 'Not filled yet'"></div>
              <label class="form-control-wrap">Personal Negotiated Fees <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Personal Negotiated Fees</label>
            </div>

            <v-select
              v-model="update_data.negotiated_fees"
              class="form-control"
              name="negotiated_fees"
              :options="field_update_options['negotiated_fees']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Personal Negotiated Fees</label>
          <div class="form-control-wrap">
            <v-text
              v-model="update_data.negotiated_fees"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="negotiated_fees"
              placeholder=""
            ></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-sm-4">
        <div class="form-group" v-if="field_update_options['manager_id'] && field_update_options['manager_id'].length">
          <div class="tooltip-v2">
            <div v-if="(data.manager_id || update_data.manager_id) && data.manager_id != update_data.manager_id">
              <div class="tooltip-v2-text left" v-html="data.manager ? data.manager.name : 'Not filled yet'"></div>
              <label class="form-control-wrap">Manager Name <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Manager Name</label>
            </div>

            <v-select
              v-model="update_data.manager_id"
              class="form-control"
              name="manager_id"
              :options="field_update_options['manager_id']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <input type="hidden" v-model="update_data.manager_id" name="manager_id" />
          <label class="form-control-wrap">Manager Name</label>
          <div class="form-control-wrap">
            <v-text v-model="manager_fields.name" class="form-control alphanumeric-field" autocomplete="off" :readonly="1"></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label class="form-control-wrap">Manager Phone</label>
          <div class="form-control-wrap">
            <v-text v-model="manager_fields.phone" class="form-control alphanumeric-field" autocomplete="off" :readonly="1"></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label class="form-control-wrap">Manager Email</label>
          <div class="form-control-wrap">
            <v-text v-model="manager_fields.email" class="form-control alphanumeric-field" autocomplete="off" :readonly="1"></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-12">
        <div class="form-group" v-if="field_update_options['address.address'] && field_update_options['address.address'].length">
          <div class="tooltip-v2">
            <div v-if="(data.address.address || update_data.address.address) && data.address.address != update_data.address.address">
              <div class="tooltip-v2-text left" v-html="data.address.address ? data.address.address : 'Not filled yet'"></div>
              <label class="form-control-wrap"> Address <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Address</label>
            </div>

            <v-select
              v-model="update_data.address.address"
              class="form-control"
              name="address[address]"
              :options="field_update_options['address.address']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Address</label>
          <div class="form-control-wrap">
            <v-text
              v-model="update_data.address.address"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="address[address]"
              placeholder=""
            ></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-sm-4">
        <div class="form-group" v-if="field_update_options['address.city'] && field_update_options['address.city'].length">
          <div class="tooltip-v2">
            <div v-if="(data.address.city || update_data.address.city) && data.address.city != update_data.address.city">
              <div class="tooltip-v2-text left" v-html="data.address.city ? data.address.city : 'Not filled yet'"></div>
              <label class="form-control-wrap">City <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">City</label>
            </div>

            <v-select
              v-model="update_data.address.city"
              class="form-control"
              name="address[city]"
              :options="field_update_options['address.city']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">City</label>
          <div class="form-control-wrap">
            <v-text
              v-model="update_data.address.city"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="address[city]"
              placeholder=""
            ></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group" v-if="field_update_options['address.state_id'] && field_update_options['address.state_id'].length">
          <div class="tooltip-v2">
            <div v-if="(data.address.state_id || update_data.address.state_id) && data.address.state_id != update_data.address.state_id">
              <div class="tooltip-v2-text left" v-html="getOptionText(data.address.state_id, 'states') || 'Not filled yet'"></div>
              <label class="form-control-wrap"> State <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">State</label>
            </div>

            <v-select
              v-model="update_data.address.state_id"
              class="form-control"
              name="address[state_id]"
              :options="field_update_options['address.state_id']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">State</label>
          <v-select v-model="update_data.address.state_id" class="form-control" name="address[state_id]" :options="options.states"></v-select>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group" v-if="field_update_options['address.zip'] && field_update_options['address.zip'].length">
          <div class="tooltip-v2">
            <div v-if="(data.address.zip || update_data.address.zip) && data.address.zip != update_data.address.zip">
              <div class="tooltip-v2-text left" v-html="data.address.zip ? data.address.zip : 'Not filled yet'"></div>
              <label class="form-control-wrap"> Zip <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Zip</label>
            </div>

            <v-select
              v-model="update_data.address.zip"
              class="form-control"
              name="address[zip]"
              :options="field_update_options['address.zip']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Zip</label>
          <div class="form-control-wrap">
            <v-text
              v-model="update_data.address.zip"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="address[zip]"
              placeholder=""
            ></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-sm-4">
        <div class="form-group" v-if="field_update_options['sales_rep_id'] && field_update_options['sales_rep_id'].length">
          <div class="tooltip-v2">
            <div v-if="(data.sales_rep_id || update_data.sales_rep_id) && data.sales_rep_id != update_data.sales_rep_id">
              <div class="tooltip-v2-text left" v-html="data.sales_rep ? data.sales_rep.name : 'Not filled yet'"></div>
              <label class="form-control-wrap">TPS Sales Rep <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">TPS Sales Rep</label>
            </div>

            <v-select
              v-model="update_data.sales_rep_id"
              class="form-control"
              name="sales_rep_id"
              :options="field_update_options['sales_rep_id']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">TPS Sales Rep</label>
          <v-select v-model="update_data.sales_rep_id" class="form-control" name="sales_rep_id" :options="options.users"></v-select>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group" v-if="field_update_options['housing_coordinator_id'] && field_update_options['housing_coordinator_id'].length">
          <div class="tooltip-v2">
            <div
              v-if="
                (data.housing_coordinator_id || update_data.housing_coordinator_id) &&
                  data.housing_coordinator_id != update_data.housing_coordinator_id
              "
            >
              <div class="tooltip-v2-text left" v-html="data.housing_coordinator ? data.housing_coordinator.name : 'Not filled yet'"></div>
              <label class="form-control-wrap">TPS Housing Coordinator <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">TPS Housing Coordinator</label>
            </div>

            <v-select
              v-model="update_data.housing_coordinator_id"
              class="form-control"
              name="housing_coordinator_id"
              :options="field_update_options['housing_coordinator_id']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">TPS Housing Coordinator</label>
          <v-select
            v-model="update_data.housing_coordinator_id"
            class="form-control"
            name="housing_coordinator_id"
            :options="options.users"
          ></v-select>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group" v-if="field_update_options['status_coordinator_id'] && field_update_options['status_coordinator_id'].length">
          <div class="tooltip-v2">
            <div
              v-if="
                (data.status_coordinator_id || update_data.status_coordinator_id) && data.status_coordinator_id != update_data.status_coordinator_id
              "
            >
              <div class="tooltip-v2-text left" v-html="data.status_coordinator ? data.status_coordinator.name : 'Not filled yet'"></div>
              <label class="form-control-wrap">TPS Status Coordinator <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">TPS Status Coordinator</label>
            </div>

            <v-select
              v-model="update_data.status_coordinator_id"
              class="form-control"
              name="status_coordinator_id"
              :options="field_update_options['status_coordinator_id']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">TPS Status Coordinator</label>
          <v-select v-model="update_data.status_coordinator_id" class="form-control" name="status_coordinator_id" :options="options.users"></v-select>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-sm-12">
        <h5 class="font-weight-bold bg-light p-2 mb-3 border-bottom text-xl">
          Company Info
        </h5>
      </div>
    </div>

    <div v-if="!update_data.company_contacts.length" class="mb-5">
      There is no company assigned for this contact
    </div>

    <div
      class="company-item mb-3"
      v-for="(company_contact, company_index) in update_data.company_contacts"
      :key="company_contact.id"
      :data-index="company_index"
    >
      <div class="form-row">
        <div class="col-sm-4">
          <div class="form-group" v-if="field_update_options['company_contacts'] && field_update_options['company_contacts'].length">
            <div class="tooltip-v2">
              <div
                v-if="
                  (getCompanyData(company_index).id || update_data.company_contacts[company_index].company.id) &&
                    getCompanyData(company_index).id != update_data.company_contacts[company_index].company.id
                "
              >
                <div
                  class="tooltip-v2-text left"
                  v-html="getCompanyData(company_index).id ? getCompanyData(company_index).name : 'Not filled yet'"
                ></div>
                <label class="form-control-wrap">
                  Company <span style="color: #ff1d25;">*</span> <span class="d-inline text-success visible">*</span>
                </label>
              </div>
              <div v-else>
                <label class="form-control-wrap">Company <span style="color: #ff1d25;">*</span></label>
              </div>

              <v-select
                v-model="update_data.company_contacts[company_index].company.id"
                class="form-control"
                :name="`company_contacts[${company_index}][id]`"
                :options="field_update_options['company_contacts']"
              ></v-select>
            </div>
            <small id="" class="form-text text-danger">Value is invalid.</small>
          </div>
          <div class="form-group" v-else>
            <input type="hidden" v-model="update_data.company_contacts[company_index].company.id" :name="`company_contacts[${company_index}][id]`" />
            <label class="form-control-wrap">Company <span style="color: #ff1d25;">*</span></label>
            <div class="form-control-wrap">
              <v-text v-model="company_fields.company.name" class="form-control alphanumeric-field" autocomplete="off" :readonly="1"></v-text>
            </div>
            <small class="form-text text-danger">Value is invalid.</small>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label class="form-control-wrap">Hub E-mail</label>
            <div class="form-control-wrap">
              <v-text v-model="company_fields.company.email" class="form-control" autocomplete="off" :readonly="1"></v-text>
            </div>
            <small class="form-text text-danger">Value is invalid.</small>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label class="form-control-wrap">Company Type</label>
            <div class="form-control-wrap">
              <v-text v-model="company_type" class="form-control" autocomplete="off" :readonly="1"></v-text>
            </div>
            <small class="form-text text-danger">Value is invalid.</small>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col col-md-6" v-if="company_fields.company.company_type_id == 1">
          <div class="form-group">
            <label class="form-control-wrap">Company Negotiated Fees</label>
            <div class="form-control-wrap">
              <v-text v-model="company_fields.company.negotiated_fees" class="form-control" autocomplete="off" :readonly="1"></v-text>
            </div>
            <small class="form-text text-danger">Value is invalid.</small>
          </div>
        </div>
        <div class="col col-md-6">
          <div class="form-group">
            <label class="form-control-wrap">Company Guidelines</label>
            <div class="form-control-wrap">
              <v-text v-model="company_fields.company.guidelines" class="form-control" autocomplete="off" :readonly="1"></v-text>
            </div>
            <small class="form-text text-danger">Value is invalid.</small>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col-sm-4">
          <div class="form-group">
            <label class="form-control-wrap">Fees Paid out of</label>
            <div class="form-control-wrap">
              <v-text v-model="housing_fee_type" class="form-control" autocomplete="off" :readonly="1"></v-text>
            </div>
            <small class="form-text text-danger">Value is invalid.</small>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label class="form-control-wrap">Carrier will pay TPS Housing direct</label>
            <div class="form-control-wrap">
              <v-text v-model="pays_directly" class="form-control" autocomplete="off" :readonly="1"></v-text>
            </div>
            <small class="form-text text-danger">Value is invalid.</small>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label class="form-control-wrap">Pays Electronically</label>
            <div class="form-control-wrap">
              <v-text v-model="pays_electronically" class="form-control" autocomplete="off" :readonly="1"></v-text>
            </div>
            <small class="form-text text-danger">Value is invalid.</small>
          </div>
        </div>
      </div>
    </div>

    <div class="my-2">
      (<span style="color: #ff1d25;">*</span>) is required fields<br />
      (<span class="text-success">*</span>) is updated fields
    </div>
  </form>
</template>

<script>
export default {
  props: ["data", "update_requests", "options"],
  data() {
    return {
      update_data: { ...JSON.parse(JSON.stringify(this.data)) },
      field_update_options: {},
      company_fields: { company: {} },
      manager_fields: {},
      watch_keys: [
        "name",
        "position",
        "email",
        "phone",
        "office",
        "office_ext",
        "invoicing_preferences",
        "personal_identifier",
        "personal_guidelines",
        "negotiated_fees",
        "license_number",
        "address.address",
        "address.city",
        "address.state_id",
        "address.zip",
        "manager_id",
        "sales_rep_id",
        "housing_coordinator_id",
        "status_coordinator_id",
        "company_contacts"
      ]
    };
  },
  computed: {
    isNew() {
      return this.data.created_at === this.data.updated_at;
    },
    company_type: {
      get() {
        return this.getCompanyOptionText("company_type_id", "company_types");
      },
      set() {}
    },
    housing_fee_type: {
      get() {
        return this.getCompanyOptionText("housing_fee_type_id", "housing_fee_types");
      },
      set() {}
    },
    pays_directly: {
      get() {
        return this.getCompanyOptionText("pays_directly", "confirm_extra");
      },
      set() {}
    },
    pays_electronically: {
      get() {
        return this.getCompanyOptionText("pays_electronically", "confirm_extra");
      },
      set() {}
    }
  },
  methods: {
    getCompanyData(index) {
      return (this.data.company_contacts && this.data.company_contacts[index] && this.data.company_contacts[index].company) || {};
    },
    getCompanyOptionText(key, options) {
      const option = this.options[options].find(s => s.id == this.company_fields.company[key]);
      return option ? option.text : "";
    },
    getOptionText(id, key) {
      const option = this.options[key].find(s => s.id == id);
      return option ? option.text : "";
    },
    updateKey(obj, field, value) {
      let keys = field.split(".");
      keys.reduce((acc, key, index) => {
        if (index === keys.length - 1) acc[key] = value;
        return acc[key];
      }, obj);
    },
    formatDate(date) {
      return moment(date)
        .local()
        .format("MM/DD/YYYY hh:mm:ss A");
    },
    getOptions(field) {
      const ids = { [field]: new Set() };
      let masterField = field.split(".").reduce((o, i) => o[i], this.data);
      const relationKey = field.replace("_id", "");
      const masterRelation = field.includes("_id") && relationKey.split(".").reduce((o, i) => o[i], this.data);

      if (field === "company_contacts") {
        const [masterCompany] = masterField;

        if (masterCompany && masterCompany.company) {
          this.company_fields = { ...masterCompany };
        }
      } else if (field === "manager_id") {
        if (masterRelation) {
          this.manager_fields = { ...masterRelation };
        }
      }

      const options = this.update_requests.reduce((acc, update_request) => {
        let updateField = field.split(".").reduce((o, i) => o[i], update_request.data);

        if ((updateField !== null || updateField !== undefined) && updateField != masterField && (updateField || masterField)) {
          masterField = typeof masterField === "string" ? masterField.replace(/'/g, "’") : masterField;
          updateField = typeof updateField === "string" ? updateField.replace(/'/g, "’") : updateField;

          const relation = field.includes("_id") && relationKey.split(".").reduce((o, i) => o[i], update_request.data);
          const masterFieldText = masterRelation ? masterRelation.name : masterField || "";
          const fieldText = relation ? relation.name : updateField || "";
          const source = update_request.source && update_request.source.policyholder ? ` - [${update_request.source.policyholder.name}]` : "";
          const updateDetails = `[${update_request.changed_by}]${source} - [${moment(update_request.updated_at)
            .local()
            .format("MM/DD/YYYY hh:mm:ss A")}]`;
          const option = {
            id: updateField || "",
            text: `${fieldText} - ${updateDetails}`
          };
          const original = {
            id: masterField || "",
            text: `${masterFieldText || ""} - [Original]`
          };

          if (field === "company_contacts") {
            const [masterCompany] = masterField;
            const [company] = updateField;
            if (masterCompany && company && masterCompany.company.id == company.company.id) {
              return acc;
            }

            if (masterCompany && masterCompany.company && !acc.length) {
              original.id = masterCompany.company.id;
              original.text = `${masterCompany.company.name} - [Original]`;
              original.data = { ...masterCompany };
            }

            if (company && company.company) {
              option.id = company.company.id;
              option.text = `${company.company.name} - ${updateDetails}`;
              option.data = { ...company };
              this.company_fields = { ...company };
            }
          } else if (field === "manager_id") {
            if (masterRelation) {
              original.data = { ...masterRelation };
            }
            if (relation) {
              option.data = { ...relation };
              this.manager_fields = { ...relation };
            }
          }

          if (!acc.length) {
            if (field === "address.state_id") {
              acc = [...this.options.states];
            } else if (["sales_rep_id", "housing_coordinator_id", "status_coordinator_id"].includes(field)) {
              acc = [...this.options.users];
            }

            acc.push(original);
            ids[field].add(original.id);
          }

          if (!ids[field].has(option.id)) {
            acc.push(option);
            ids[field].add(option.id);
          }

          this.updateKey(this.update_data, field, updateField);
        }

        return acc;
      }, []);

      return options;
    }
  },
  watch: {
    "update_data.manager_id"(newVal) {
      if (!this.field_update_options.manager_id) return;

      const manager = this.field_update_options.manager_id.find(m => (newVal ? m.id == newVal : !m.id));

      if (!manager) return;

      this.manager_fields = { ...manager.data };
    },
    "update_data.company_contacts": {
      handler(newValue) {
        const selectedCompany = newValue[0].company;

        if (!this.field_update_options.company_contacts || !selectedCompany) return;

        const company = this.field_update_options.company_contacts.find(m => (selectedCompany.id ? m.id == selectedCompany.id : !m.id));

        if (!company) return;

        this.company_fields = { ...company.data };
      },
      deep: true
    }
  },
  mounted() {
    const options = new Map();
    this.watch_keys.map(field => options.set(field, this.getOptions(field)));
    this.field_update_options = Object.fromEntries(options);
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/alerts/contact-approval.vue